<template>
  <div class="home sub-menu sub-menu-small h-auto">
    <v-btn text class="ma-2" to="/">
      <v-img
        class="mt-2"
        :src="require('../assets/icons/user-icon.png')"
        contain
        width="50"
        height="50"
      ></v-img>
      <span class="py-2">User Settings</span>
    </v-btn>
    <v-btn text class="ma-2" to="/">
      <v-img
        class="mt-2"
        :src="require('../assets/icons/user-icon.png')"
        contain
        width="50"
        height="50"
      ></v-img>
      <span class="py-2">Box Settings</span>
    </v-btn>
    <v-btn text class="ma-2" to="/">
      <v-img
        class="mt-2"
        :src="require('../assets/icons/user-icon.png')"
        contain
        width="50"
        height="50"
      ></v-img>
      <span class="py-2">Event Log</span>
    </v-btn>
    <v-btn text class="ma-2" to="/">
      <v-img
        class="mt-2"
        :src="require('../assets/icons/user-icon.png')"
        contain
        width="50"
        height="50"
      ></v-img>
      <span class="py-2">Logout</span>
    </v-btn>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {},
  async created() {
    // if (this.pageName === "mobile") {
    //   this.menuItems = [];
    //   Object.keys(Menus).forEach(element => {
    //     this.menuItems = this.menuItems.concat(Menus[element]);
    //     // console.log('Menus: ', element, Menus[element], this.menuItems );
    //   });
    // }
    // await this.filterMenuItems();
  }
};
</script>

<style>
.home.sub-menu {
  max-height: 125px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.sub-menu-small .v-image .v-image__image {
  max-width: 44px !important;
  max-height: 44px;
}
.sub-menu-small .v-btn {
  min-width: 60px;
  text-transform: capitalize;
}
.h-auto .v-btn {
  height: auto !important;
  min-width: 70px !important;
}
.h-auto .v-btn .v-btn__content {
  flex-direction: column;
}
.h-auto .v-btn .v-btn__content .v-image__image {
  width: 50px;
  opacity: 0.9;
  -moz-border-radius: 30%;
  border-radius: 30%;
}
a {
  color: #0b7894 !important;
}
</style>
